import { Component, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { OnBoardingService } from '../../../api-services/onboarding.service';
import { VerifyOnboardingUserRequest } from '../../../models/onboarding/verifyOnboardUserRequest.model';
import { IndividualAccountService } from '../../../api-services/individual-account.service';
import { IndividualAccountStaging } from '../../../models/individual-account/individual-account-staging';
import { AccountService } from '../../../api-services';


@Component({
  selector: 'app-onboarding-code',
  templateUrl: './onboarding-code.component.html',
  styleUrls: ['./onboarding-code.component.css']
})
export class OnboardingCodeComponent implements OnInit {
  title = 'otp';
  otpCode = "";
  codeForm: FormGroup;
  formInput = ['input1', 'input2', 'input3', 'input4', 'input5', 'input6'];
  @ViewChildren('formRow') rows: any;
  onboardingUsersId: number;
  errorMessages = [];
  lastPaste: boolean = false;
  pageFrom: string = null;
  encryptedIndividualAccountStagingId: string = null;

  constructor(private router: Router
    , private activatedRoute: ActivatedRoute
    , private fb: FormBuilder
    , private onBoardingService: OnBoardingService
    , private individualAccountService: IndividualAccountService
    , private accountService: AccountService,) {
    this.codeForm = this.toFormGroup(this.formInput);
  }

  ngOnInit(): void {
    this.encryptedIndividualAccountStagingId = this.activatedRoute.snapshot.queryParams["id"];
    this.pageFrom = this.activatedRoute.snapshot.queryParams["page"];
    if (this.pageFrom == "indReg") {

    }
    else {
    this.sendVerificationCode();
    }
    
  }

  sendVerificationCode() {
    var val = this.activatedRoute.snapshot.paramMap.get('id');
    this.onBoardingService.sendVerificationCode(val).subscribe(
      (response: any) => {
        this.onboardingUsersId = response.userId;
        localStorage.setItem("onboardingUsersId", this.onboardingUsersId.toString());
        //if (response.activationDate == null) {
        //  this.router.navigate(['/setpwd']);
        //}
        //else
        if (response.activationDate != null) {
          this.router.navigate(['/login']);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  toFormGroup(elements) {
    const group: any = {};

    elements.forEach(key => {
      group[key] = new FormControl('', Validators.required);
    });
    return new FormGroup(group);
  }

  keyUpEvent(event, index) {
    if (this.lastPaste) return;

    this.otpCode = ""
    let pos = index;
    
      if (this.codeForm.value[index] == '' || event.ctrlKey) {
      this.codeForm.value[index] = "";
      pos = index;
    } else if (event.keyCode === 8 && event.which === 8) {
      pos = index - 1;
    }
    else {
      pos = index + 1
    }

    if (pos > -1 && pos < this.formInput.length) {
      this.rows._results[pos].nativeElement.focus();
    }
    
    if (index == 5 || this.codeForm.status.toLocaleLowerCase() === 'valid') {
      this.errorMessages = [];
      Object.values(this.codeForm.value).forEach((el , index) => {
        this.otpCode = this.otpCode + el ;
        index == 2 ? this.otpCode = this.otpCode + '-' : '';
      })
    }
  }

  onPaste(event: ClipboardEvent) {
    this.lastPaste = true;
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    this.otpCode = pastedText.replaceAll(' ', '').trim();

    Object.keys(this.codeForm.value).forEach((el , index) => {
      this.codeForm.get(el)!.setValue(this.otpCode?.replace('-', '')?.split('')[index])
    });
    setTimeout(() => {this.lastPaste = false}, 1000)
  }

  onSubmit() {
    this.codeForm.markAllAsTouched();
    this.errorMessages = [];

    if (this.pageFrom == "indReg") {

      if (this.codeForm.valid) {
        var objIndRequest = {
          verificationCode: this.otpCode,
          encUserId: this.encryptedIndividualAccountStagingId
        } as IndividualAccountStaging;

        this.individualAccountService.verifyIndividualAccountStaging(objIndRequest).subscribe(
          (response: any) => {
            if (response) {
              if (localStorage.hasOwnProperty('individualAccountStagingId')) {
                localStorage.removeItem('individualAccountStagingId');
              }
              localStorage.setItem("userRole", "Individual User");
              localStorage.setItem("individualAccountStagingId", response.individualAccountStagingId);
              this.accountService.setToken(response, response.token);
              this.router.navigate(['individual-registration/npn']); //, { state: { individualAccountStagingId: response.individualAccountStagingId } }
            } else {
              this.errorMessages.push(`Invalid code found - (${this.otpCode})`);
            }
          },
          (error: any) => {
            // console.log(error);
            this.errorMessages.push(error.message);
          }
        );
      }

    }
    else {
      if (this.codeForm.valid && this.onboardingUsersId > 0) {
        var objRequest = {
          activationCode: this.otpCode,
          onboardingUserId: this.onboardingUsersId
        } as VerifyOnboardingUserRequest;

        this.onBoardingService.verifyOnboardUser(objRequest).subscribe(
          (response: any) => {
            if (response) {
              this.router.navigate(['/setpwd']);
            } else {
              this.errorMessages.push(`Invalid code found - (${this.otpCode})`);
            }
          },
          (error: any) => {
            // console.log(error);
            this.errorMessages.push(error.message);
          }
        );
      }
    }

  }

}
